export const requestUserLocation = (timeoutMs: number = 10000) => {
  return new Promise((resolve: (position: GeolocationPosition) => void, reject) => {
    if (!navigator.geolocation) {
      return reject(new Error('Geolocation is not supported by this browser.'));
    }

    const options: PositionOptions = {
      enableHighAccuracy: true,
      timeout: timeoutMs,
      // maximumAge: 0, // Force fresh location
    };

    navigator.geolocation.getCurrentPosition(
      (position) => resolve(position),
      (error) => reject(error),
      options,
    );
  });
};
